import React from 'react'

const Reviews = () => {
    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Reviews</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="our-client-sec inner">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12  ">
                            <div className="our-client-heading wow bounceIn" data-wow-duration="2s">
                                <h2>what people say</h2>
                                <p>Lorem ipsum dLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut lab
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod temp
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="our-client-silder-row">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="client-box inner wow fadeInUp" data-wow-duration="2s">
                                    <i className="quotess fas fa-quote-left" />
                                    <div className="client-ineer-box">
                                        <ul>
                                            <li>
                                                <h4>Selena Clark<span>Manager</span></h4>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                    <i className="fas fa-star" />
                                                </div>
                                            </li>
                                        </ul>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Reviews